import { combineReducers } from 'redux';
import {
  INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT,
  INGREDIENT_RECIPES_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT,
  INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING,
  INGREDIENT_RECIPES_ADD_ITEMS_SET_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS,
  INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT,
  INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING,
  INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD,
  INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN,
  INGREDIENT_RECIPES_EXPORT_DONE,
  INGREDIENT_RECIPES_EXPORT_START,
  INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL,
  INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL,
  INGREDIENT_RECIPES_HIDE_DELETE_MODAL,
  INGREDIENT_RECIPES_HIDE_IMPORT_MODAL,
  INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_RECIPES_IS_SUBMITTING_FORM,
  INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN,
  INGREDIENT_RECIPES_SET_ASYNCJOBID,
  INGREDIENT_RECIPES_SET_CREATED_OUTLETS,
  INGREDIENT_RECIPES_SET_CURRENT_PAGE,
  INGREDIENT_RECIPES_SET_FILTER_STATE,
  INGREDIENT_RECIPES_SET_ITEM_VARIANT,
  INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN,
  INGREDIENT_RECIPES_SET_OUTLETS,
  INGREDIENT_RECIPES_SET_RECIPES_DETAIL,
  INGREDIENT_RECIPES_SET_RECIPES_FORM,
  INGREDIENT_RECIPES_SET_RECIPES,
  INGREDIENT_RECIPES_SET_TOTAL_PAGE,
  INGREDIENT_RECIPES_SET_TOTAL_COUNT,
  INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL,
  INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL,
  INGREDIENT_RECIPES_SHOW_DELETE_MODAL,
  INGREDIENT_RECIPES_SHOW_IMPORT_MODAL,
  INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_RECIPES_UNSET_FILTER_STATE,
  INGREDIENT_RECIPES_OPEN_CREATE_RECIPES_MODAL,
  INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES_HIDE_MODAL,
  INGREDIENT_RECIPES_RESET_MODAL_IMPORT_RECIPE,
  INGREDIENT_RECIPES_ERROR_VALIDATION_CSV,
  INGREDIENT_RECIPES_NEXT_STEP_FORM_MODAL,
  INGREDIENT_RECIPES_BACK_STEP_FORM_MODAL,
  INGREDIENT_RECIPES_NEXT_STEP_FIRST_TIME_USER_EXPERIENCE,
  INGREDIENT_RECIPES_IMPORT_TYPE,
  INGREDIENT_RECIPES_DROP_FILE_CREATE_RECIPES_FORM,
  INGREDIENT_RECIPES_SAVE_FILE,
  INGREDIENT_RECIPES_SET_REPONSE_FAILED_IMPORT_RECIPE,
  INGREDIENT_RECIPES_UPLOAD_FILE_SUCCESS,
  INGREDIENT_RECIPES_UPDATE_INCORRECT,
  INGREDIENT_RECIPES_LOADING_UPLOAD,
  INGREDIENT_RECIPES_RESET_LOADING,
} from 'actions/ingredients/recipes/constants';
import createReducer from 'utils/createReducer';

const ingredientAlreadyAddedAlert = createReducer(false, {
  [INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT]: () => true,
  [INGREDIENT_RECIPES_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT]: () => false,
});

const ingredientIngredient = createReducer([], {
  [INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT]: (draft, { payload }) =>
    payload.ingredient || null,
});

const ingredientIngredientQuantity = createReducer(null, {
  [INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT]: (draft, { payload }) =>
    payload.ingredientQuantity,
});

const ingredientIngredients = createReducer([], {
  [INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS]: (draft, { payload }) =>
    payload.ingredients,
  [INGREDIENT_RECIPES_ADD_ITEMS_SET_INGREDIENTS]: (draft, { payload }) =>
    payload.ingredients,
});

const ingredientIsLoading = createReducer(false, {
  [INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING]: () => true,
  [INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING]: () => false,
});

const ingredientKeyword = createReducer(null, {
  [INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD]: (draft, { payload }) =>
    payload.keyword,
});

const ingredientSelectedId = createReducer(null, {
  [INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT]: (
    draft,
    { payload: { ingredient } }
  ) => (ingredient ? ingredient.id : null),
});

const addIngredients = combineReducers({
  alreadyAddedAlert: ingredientAlreadyAddedAlert,
  ingredient: ingredientIngredient,
  ingredientQuantity: ingredientIngredientQuantity,
  ingredients: ingredientIngredients,
  isLoading: ingredientIsLoading,
  keyword: ingredientKeyword,
  selectedId: ingredientSelectedId,
});

const createdOutlets = createReducer(null, {
  [INGREDIENT_RECIPES_SET_CREATED_OUTLETS]: (draft, { payload }) =>
    payload.createdOutlets,
});

const currentPage = createReducer(null, {
  [INGREDIENT_RECIPES_SET_CURRENT_PAGE]: (draft, { payload }) => payload.page,
});

const filterState = createReducer(
  {
    keyword: '',
  },
  {
    [INGREDIENT_RECIPES_SET_FILTER_STATE]: (draft, { payload }) => {
      draft.keyword = payload.keyword;
    },
    [INGREDIENT_RECIPES_UNSET_FILTER_STATE]: draft => {
      draft.keyword = '';
    },
  }
);

const idAsyncJob = createReducer(null, {
  [INGREDIENT_RECIPES_SET_ASYNCJOBID]: (draft, { payload }) =>
    payload.idAsyncJob,
});

const ingredientAdjustmentDetail = createReducer(null, {});

const ingredientRecipes = createReducer([], {});

const isExportLoading = createReducer(false, {
  [INGREDIENT_RECIPES_EXPORT_START]: () => true,
  [INGREDIENT_RECIPES_EXPORT_DONE]: () => false,
});

const isSubmittingForm = createReducer(false, {
  [INGREDIENT_RECIPES_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const itemsDropdowns = createReducer([], {
  [INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN]: (draft, { payload }) =>
    payload.itemsDropdowns,
});

const itemVariant = createReducer([], {
  [INGREDIENT_RECIPES_SET_ITEM_VARIANT]: (draft, { payload }) =>
    payload.itemVariant,
});

const openRightColumn = createReducer(false, {
  [INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN]: () => true,
  [INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  [INGREDIENT_RECIPES_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const recipes = createReducer([], {
  [INGREDIENT_RECIPES_SET_RECIPES]: (draft, { payload }) => payload.recipes,
});

const recipesDetail = createReducer(null, {
  [INGREDIENT_RECIPES_SET_RECIPES_DETAIL]: (draft, { payload }) =>
    payload.recipes,
});

const recipesForm = createReducer(
  {
    item_id: null,
    item_name: null,
    item_variant_id: null,
    item_variant_name: null,
    recipe_ingredients: [],
    sku: null,
  },
  {
    [INGREDIENT_RECIPES_SET_RECIPES_FORM]: (draft, { payload }) =>
      payload.recipesForm,
  }
);

const showAddItemsModal = createReducer(false, {
  [INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL]: () => true,
  [INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL]: () => false,
});

const showConfirmSubmitModal = createReducer(false, {
  [INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL]: () => true,
  [INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL]: () => false,
});

const showDeleteModal = createReducer(false, {
  [INGREDIENT_RECIPES_SHOW_DELETE_MODAL]: () => true,
  [INGREDIENT_RECIPES_HIDE_DELETE_MODAL]: () => false,
});

const showImportModal = createReducer(false, {
  [INGREDIENT_RECIPES_SHOW_IMPORT_MODAL]: () => true,
  [INGREDIENT_RECIPES_HIDE_IMPORT_MODAL]: () => false,
});
const showSaveToAllOutletsModal = createReducer(false, {
  [INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL]: () => true,
  [INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL]: () => false,
});

const totalPage = createReducer(null, {
  [INGREDIENT_RECIPES_SET_TOTAL_PAGE]: (draft, { payload }) => payload.page,
});

const totalCount = createReducer(null, {
  [INGREDIENT_RECIPES_SET_TOTAL_COUNT]: (draft, { payload }) =>
    payload.totalCount,
});

const showCreateRecipesModal = createReducer(false, {
  [INGREDIENT_RECIPES_OPEN_CREATE_RECIPES_MODAL]: () => true,
  [INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES_HIDE_MODAL]: () => false,
});

const createRecipesForm = createReducer(
  {
    isLoading: false,
    step: 1,
    isUploadImage: false,
    fileFormData: null,
    stepFirstTimeUserExperience: 0,
  },
  {
    [INGREDIENT_RECIPES_NEXT_STEP_FORM_MODAL]: draft => {
      draft.step = draft.step + 1;
    },
    [INGREDIENT_RECIPES_BACK_STEP_FORM_MODAL]: draft => ({
      ...draft,
      step: draft.step - 1,
      isUploadImage: false,
      fileFormData: null,
    }),
    [INGREDIENT_RECIPES_NEXT_STEP_FIRST_TIME_USER_EXPERIENCE]: (
      draft,
      { payload }
    ) => {
      draft.stepFirstTimeUserExperience = payload;
    },
    [INGREDIENT_RECIPES_IMPORT_TYPE]: (draft, { payload }) => {
      draft.importType = payload;
    },
    [INGREDIENT_RECIPES_DROP_FILE_CREATE_RECIPES_FORM]: draft => {
      draft.isUploadImage = !draft.isUploadImage;
    },
    [INGREDIENT_RECIPES_SAVE_FILE]: (draft, { payload }) => {
      draft.fileFormData = payload;
    },
    [INGREDIENT_RECIPES_SET_REPONSE_FAILED_IMPORT_RECIPE]: (
      draft,
      { payload }
    ) => ({
      ...draft,
      isError: true,
      messages: payload.messages,
      isLoading: false,
      isUploadImage: false,
    }),
    [INGREDIENT_RECIPES_UPLOAD_FILE_SUCCESS]: () => ({
      isLoading: false,
      step: 4,
      isUploadImage: false,
      fileFormData: null,
    }),
    [INGREDIENT_RECIPES_RESET_MODAL_IMPORT_RECIPE]: () => ({
      isError: false,
      isLoading: false,
      step: 1,
      isUploadImage: false,
      fileFormData: null,
      stepFirstTimeUserExperience: 0,
    }),
    [INGREDIENT_RECIPES_ERROR_VALIDATION_CSV]: (draft, { payload }) => {
      draft.isError = true;
      draft.messages = payload;
    },
    [INGREDIENT_RECIPES_UPDATE_INCORRECT]: draft => {
      draft.step = 3;
    },
    [INGREDIENT_RECIPES_LOADING_UPLOAD]: draft => {
      draft.isLoading = true;
    },
    [INGREDIENT_RECIPES_RESET_LOADING]: draft => {
      draft.isLoading = false;
    },
  }
);

export default combineReducers({
  addIngredients,
  createdOutlets,
  currentPage,
  filterState,
  idAsyncJob,
  ingredientAdjustmentDetail,
  ingredientRecipes,
  isExportLoading,
  isSubmittingForm,
  itemsDropdowns,
  itemVariant,
  openRightColumn,
  outlets,
  recipes,
  recipesDetail,
  recipesForm,
  showAddItemsModal,
  showConfirmSubmitModal,
  showDeleteModal,
  showImportModal,
  showSaveToAllOutletsModal,
  totalPage,
  totalCount,
  showCreateRecipesModal,
  createRecipesForm,
});
